"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedUserRendererFactory = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const RelatedUserRendererFactory = (viewField, idx, pdf = false) => (item) => {
    const user = viewField.propertyName ? item[viewField.propertyName] : item;
    const linkPage = viewField === null || viewField === void 0 ? void 0 : viewField.linkPage;
    const { goTo } = (0, useNav_1.default)();
    const handleClick = (0, react_1.useCallback)(() => {
        if (!linkPage || !user)
            return;
        goTo(linkPage, { id: user.id });
    }, [goTo, linkPage, user]);
    if (!(user === null || user === void 0 ? void 0 : user.title))
        return null;
    if (pdf) {
        return react_1.default.createElement(Text_1.default, null, user === null || user === void 0 ? void 0 : user.title);
    }
    return (react_1.default.createElement(DataPill_1.default, { value: user === null || user === void 0 ? void 0 : user.title, type: DataType_1.default.STAFF, avatarUrl: user === null || user === void 0 ? void 0 : user.profileImageUrl, textWidth: '100%', onClick: linkPage ? handleClick : undefined }));
};
exports.RelatedUserRendererFactory = RelatedUserRendererFactory;
exports.default = exports.RelatedUserRendererFactory;
